module.exports = __webpack_public_path__ + "img/blog-2.jpg?8255f7c2d6b4aa6f0b77e0bfa0aafb0d";